var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 13.399999618530273 106.19999694824219 35",
    "data-asc": 0.968,
    width: 106.19999694824219,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.40L26.65 13.40L26.65 19.75L7.90 19.75L7.90 27.65L24.75 27.65L24.75 34L7.90 34L7.90 42.05L27.20 42.05L27.20 48.40L0 48.40L0 13.40ZM33.40 13.40L42.20 13.40L53.10 35.20L63.90 13.40L72.65 13.40L72.65 48.40L65.55 48.40L65.55 24.30L55.60 44.85L50.50 44.85L40.50 24.30L40.50 48.40L33.40 48.40L33.40 13.40ZM76.95 13.40L106.20 13.40L106.20 19.90L95.50 19.90L95.50 48.40L87.60 48.40L87.60 19.90L76.95 19.90L76.95 13.40Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7405a7718ca6028296e445c830ecfaa4.svg";
export { ForwardRef as ReactComponent };